import * as e from "react";
import { jsx as a } from "./_virtual/jsx-runtime.js";
const t = /*#__PURE__*/ e.createContext(!1), n = (param)=>/* @__PURE__ */ {
    let { isInverse: r , children: s  } = param;
    return a(t.Provider, {
        value: !!r,
        children: s
    });
}, i = ()=>e.useContext(t);
export { n as ThemeVariant, i as useIsInverseVariant };
